import { forwardRef } from "react";

import { tw } from "~/utils";

export const TableHeader = forwardRef<
  HTMLTableSectionElement,
  React.HTMLAttributes<HTMLTableSectionElement>
>(({ className, ...props }, ref) => (
  <thead
    ref={ref}
    className={tw(
      "border-light-lavender-gray border-b bg-gray-50 [&_tr:last-child]:border-0",
      className,
    )}
    {...props}
  />
));
TableHeader.displayName = "TableHeader";
